import React, { useMemo } from 'react';
import classNames from 'classnames';
import { ObjectValues } from 'types';
import ResolvePopup from 'components/ResolvePopup';

import './PendingActionPill.styles.scss';

export const PENDING_ACTION_VARIANT = {
  DEFAULT: 'default',
  WARNING: 'warning',
  ERROR: 'error',
} as const;

type PendingActionVariant = ObjectValues<typeof PENDING_ACTION_VARIANT>;

type PendingActionPillProps = {
  className?: string;
  variant?: PendingActionVariant;
  tooltipContent?: string;
  text: string;
};

const PendingActionPill: React.FC<PendingActionPillProps> = (props) => {
  const {
    children,
    className,
    tooltipContent,
    text,
    variant = PENDING_ACTION_VARIANT.DEFAULT,
  } = props;

  const classes = classNames('pending-action-pill', variant, className);

  const Content = useMemo(
    () => (
      <div className={classes}>
        {children}
        {text}
      </div>
    ),
    [children, classes, text],
  );

  if (!tooltipContent) return Content;

  return (
    <ResolvePopup onHover popupContent={tooltipContent}>
      {Content}
    </ResolvePopup>
  );
};

export default PendingActionPill;
